import { Fragment, useState } from 'react'

import { Button } from '@material-ui/core'

import api from 'common/api'

import RegisterModal from './RegisterModal'

type RegisterActionProps = {
  show: boolean
  onClose: () => void
  eventId: string
  highSchoolName: string
  onEventChange: () => void
  allowRepMeeting?: boolean
  placeName?: string
  allowRepLocationType: boolean
  meetingLink?: string
}
const RegisterAction = ({
  show = false,
  onClose,
  eventId,
  highSchoolName,
  onEventChange,
  allowRepMeeting,
  placeName,
  meetingLink,
  allowRepLocationType,
}: RegisterActionProps) => {
  const [isConfirming, setIsConfirming] = useState(false)
  const [hasRegisterError, setHasRegisterError] = useState(false)
  const register = (newPlaceName?: string, isVirtual?: boolean) => {
    setIsConfirming(true)
    const requestBody = {
      ...(placeName !== newPlaceName && { Location: { PlaceName: newPlaceName } }),
      ...(allowRepLocationType && { Virtual: isVirtual || false }),
    }
    api
      .post(`/api/highschools/visits/${eventId}/register`, requestBody)
      .then(() => {
        onEventChange()
        onClose()
        setIsConfirming(false)
        setHasRegisterError(false)
      })
      .catch(() => {
        setHasRegisterError(true)
        setIsConfirming(false)
      })
  }
  return (
    <RegisterModal
      show={show}
      title="Confirm Registration"
      onClose={() => onClose()}
      onConfirm={register}
      allowRepMeeting={allowRepMeeting}
      placeName={placeName}
      meetingLink={meetingLink}
      isConfirming={isConfirming}
      hasRegisterError={hasRegisterError}
      allowRepLocationType={allowRepLocationType}
    >
      <Fragment>
        <span>
          Are you sure you want to register for a visit to <strong>{highSchoolName}</strong>?
        </span>
        <div className="shared-information-label">
          Registration for this event will share your contact information with this school.
        </div>
      </Fragment>
    </RegisterModal>
  )
}
const Trigger = ({ onOpen }: { onOpen: () => void }) => {
  return (
    <Button
      variant="contained"
      color="primary"
      size="small"
      onClick={() => onOpen()}
    >
      Register
    </Button>
  )
}

RegisterAction.Trigger = Trigger
export default RegisterAction
